/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useRef,
  useCallback,
  useContext,
} from "react";
import { Link, useHistory } from "react-router-dom";
import Form, {
  Item,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  Label,
} from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import DropDownButton from "devextreme-react/drop-down-button";
import notify from "devextreme/ui/notify";
import { useAuth } from "../../contexts/auth";
import "./style.scss";
import { LanguageContext } from "../../App";
// import UsingIntl from "../../services/using_intl";
const LoginEnum = [
  {
    id: 0,
    Username: "Tên đăng nhập",
    Password: "Mật khẩu",
    Forgotpassword: "Quên mật khẩu?",
    Login: "Đăng nhập",
    placeholderUser: "Nhập tên đăng nhập",
    placeholderPassword: "Nhập mật khẩu",
  },
  {
    id: 1,
    Username: "Username",
    Password: "Password",
    Forgotpassword: "Forgot password?",
    Login: "Login",
    placeholderUser: "Enter your username",
    placeholderPassword: "Enter your password",
  },
  {
    id: 2,
    Forgotpassword: "取引",
    Password: "パスワード",
    Username: "ユーザー名",
    Login: "ログイン",
    placeholderUser: "ユーザー名を入力して下さい",
    placeholderPassword: "パスワードを入力して下さい",
  },
];
const langOptions = [
  { id: 1, value: "en", name: "English", icon: "/assets/images/flags/en.png" },
  {
    id: 2,
    value: "vi",
    name: "Tiếng Việt",
    icon: "/assets/images/flags/vi.png",
  },
  {
    id: 3,
    value: "ja",
    name: "日本語",
    icon: "/assets/images/flags/ja.png",
  },
];

export default function LoginForm() {
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState({});
  const formData = useRef({});
  const history = useHistory();
  const { signIn } = useAuth();
  const { language, setLanguage } = useContext(LanguageContext);

  const swithFlags = (lang) => {
    localStorage.setItem("locale", lang);

    const object = {
      en: "/assets/images/flags/en.png",
      vi: "/assets/images/flags/vi.png",
      ja: "/assets/images/flags/ja.png",
    };

    return object[lang] ?? "/assets/images/flags/vi.png";
  };

  const changeDisplayedName = (language) => {
    switch (language) {
      case "en":
        setText(LoginEnum[1]);
        break;
      case "vi":
        setText(LoginEnum[0]);
        break;
      case "ja":
        setText(LoginEnum[2]);
        break;

      default:
        setText(LoginEnum[1]);
        break;
    }
  };

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const { UserName, StoredPassword } = formData.current;
      setLoading(true);

      try {
        const result = await signIn(UserName, StoredPassword);
        if (!result.isOk) {
          // Hiển thị thông báo lỗi cụ thể từ API
          let errorMessage = result.message;
          
          // Nếu không có message từ API, sử dụng message đa ngôn ngữ
          if (!errorMessage) {
            const locale = localStorage.getItem('locale') || 'vi';
            if (locale === 'vi') {
              errorMessage = "Đăng nhập thất bại";
            } else if (locale === 'ja') {
              errorMessage = "ログインに失敗しました";
            } else {
              errorMessage = "Login failed";
            }
          }
          
          const errorType = result.type || "error";
          notify(errorMessage, errorType, 5000); // Tăng timeout lên 5000ms
          setLoading(false);
          return;
        }
        
        history.push("/home");
      } catch (error) {
        // Hiển thị thông báo lỗi chi tiết
        let errorMessage = error.response?.data?.message || 
                          error.response?.data?.Message || 
                          error.message;
        
        // Nếu không có message, sử dụng message đa ngôn ngữ
        if (!errorMessage) {
          const locale = localStorage.getItem('locale') || 'vi';
          if (locale === 'vi') {
            errorMessage = "Đã xảy ra lỗi khi đăng nhập";
          } else if (locale === 'ja') {
            errorMessage = "ログイン中にエラーが発生しました";
          } else {
            errorMessage = "An error occurred during login";
          }
        }
        
        notify(errorMessage, "error", 5000);
      } finally {
        setLoading(false);
      }
    },
    [signIn, history]
  );

  return (
    <>
      <form className={"login-form"} onSubmit={onSubmit} key={"ads"}>
        <Form
          formData={formData.current}
          disabled={loading}
          labelLocation="top"
        >
          <Item
            dataField={"UserName"}
            editorType={"dxTextBox"}
            editorOptions={{
              placeholder: text.placeholderUser ?? "Enter your username",
              mode: "username",
            }}
          >
            <Label text={text.Username ?? "Username"} />
            <RequiredRule message="Username is required" />
          </Item>
          <Item
            dataField={"StoredPassword"}
            editorType={"dxTextBox"}
            editorOptions={{
              placeholder: text.placeholderPassword ?? "Enter your username",
              mode: "password",
            }}
          >
            <Label text={text.Password ?? "Password"} />
            <RequiredRule message="Password is required" />
          </Item>
          <Item>
            <div className={"group-sub"}>
              <DropDownButton
                splitButton={false}
                useSelectMode={false}
                stylingMode={"text"}
                items={langOptions}
                icon={swithFlags(language)}
                valueExpr={"id"}
                displayExpr={"name"}
                dropDownOptions={{
                  wrapperAttr: { class: "dropdown-language" },
                }}
                onItemClick={(e) => {
                  setLanguage(e.itemData.value);
                  changeDisplayedName(e.itemData.value);
                }}
              />

              <Link to={"/reset-password"}>
                {text.Forgotpassword ?? "Forgot password?"}
              </Link>
            </div>
          </Item>
          <ButtonItem cssClass="button-rounded mt-3">
            <ButtonOptions
              width={"100%"}
              type={"default"}
              stylingMode="outlined"
              useSubmitBehavior={true}
              key={"loginBtn"}

            >
              <span className="dx-button-text">
                {loading ? (
                  <LoadIndicator
                    id="image-indicator"
                    width={"24px"}
                    height={"24px"}
                    visible={true}
                  />
                ) : (
                  text.Login ?? "Login"
                )}
              </span>
            </ButtonOptions>
          </ButtonItem>
        </Form>
      </form>
    </>
  );
}
